module.exports = __webpack_public_path__ + "static/media/34631643703825banner2.2bb62574.jpg";